import { RegionInfo } from '../types';

export const REGIONS: RegionInfo[] = [
  {
    code: 'US',
    name: 'United States',
    currency: 'USD',
    currencySymbol: '$',
    flag: '🇺🇸',
    locale: 'en-US',
    popularCurrencies: ['EUR', 'GBP', 'CAD', 'MXN', 'JPY'],
    taxYear: '2026 Tax Year (IRS)',
    standardVatRate: 7.25, // Avg State Sales Tax
  },
  {
    code: 'GB',
    name: 'United Kingdom',
    currency: 'GBP',
    currencySymbol: '£',
    flag: '🇬🇧',
    locale: 'en-GB',
    popularCurrencies: ['EUR', 'USD', 'INR', 'CHF', 'AUD'],
    taxYear: '2026/27 PAYE (HMRC)',
    standardVatRate: 20.0,
  },
  {
    code: 'CA',
    name: 'Canada',
    currency: 'CAD',
    currencySymbol: '$',
    flag: '🇨🇦',
    locale: 'en-CA',
    popularCurrencies: ['USD', 'EUR', 'GBP', 'INR', 'CNY'],
    taxYear: '2026 Tax Year (CRA)',
    standardVatRate: 13.0,
  },
  {
    code: 'FR',
    name: 'France',
    currency: 'EUR',
    currencySymbol: '€',
    flag: '🇫🇷',
    locale: 'fr-FR',
    popularCurrencies: ['USD', 'GBP', 'CHF', 'XOF', 'CAD'],
    taxYear: 'Barème 2026 (DGFiP / URSSAF)',
    standardVatRate: 20.0,
  },
  {
    code: 'DE',
    name: 'Germany',
    currency: 'EUR',
    currencySymbol: '€',
    flag: '🇩🇪',
    locale: 'de-DE',
    popularCurrencies: ['USD', 'GBP', 'CHF', 'PLN', 'TRY'],
    taxYear: 'Steuerjahr 2026 (BMF)',
    standardVatRate: 19.0,
  },
  {
    code: 'CH',
    name: 'Switzerland',
    currency: 'CHF',
    currencySymbol: 'CHF',
    flag: '🇨🇭',
    locale: 'de-CH',
    popularCurrencies: ['EUR', 'USD', 'GBP', 'SGD', 'JPY'],
    taxYear: 'Impôt 2026 (AFC / 26 Cantons)',
    standardVatRate: 8.1,
  },
  {
    code: 'AU',
    name: 'Australia',
    currency: 'AUD',
    currencySymbol: '$',
    flag: '🇦🇺',
    locale: 'en-AU',
    popularCurrencies: ['USD', 'NZD', 'GBP', 'EUR', 'SGD'],
    taxYear: '2026 ATO Tax Year',
    standardVatRate: 10.0,
  },
  {
    code: 'SG',
    name: 'Singapore',
    currency: 'SGD',
    currencySymbol: 'S$',
    flag: '🇸🇬',
    locale: 'en-SG',
    popularCurrencies: ['USD', 'MYR', 'EUR', 'GBP', 'AUD'],
    taxYear: 'Year of Assessment 2026 (IRAS)',
    standardVatRate: 9.0,
  },
  {
    code: 'IN',
    name: 'India',
    currency: 'INR',
    currencySymbol: '₹',
    flag: '🇮🇳',
    locale: 'en-IN',
    popularCurrencies: ['USD', 'AED', 'GBP', 'EUR', 'CAD'],
    taxYear: 'FY 2026-27 (New Tax Regime Sec 115BAC)',
    standardVatRate: 18.0,
  },
  {
    code: 'JP',
    name: 'Japan',
    currency: 'JPY',
    currencySymbol: '¥',
    flag: '🇯🇵',
    locale: 'ja-JP',
    popularCurrencies: ['USD', 'EUR', 'AUD', 'GBP', 'KRW'],
    taxYear: '2026 NTA Tax Tables (国税庁)',
    standardVatRate: 10.0,
  },
  {
    code: 'AE',
    name: 'United Arab Emirates',
    currency: 'AED',
    currencySymbol: 'AED',
    flag: '🇦🇪',
    locale: 'en-AE',
    popularCurrencies: ['USD', 'INR', 'EUR', 'GBP', 'PKR'],
    taxYear: '2026 Federal Tax Authority (FTA)',
    standardVatRate: 5.0,
  },
  {
    code: 'BR',
    name: 'Brazil',
    currency: 'BRL',
    currencySymbol: 'R$',
    flag: '🇧🇷',
    locale: 'pt-BR',
    popularCurrencies: ['USD', 'EUR', 'GBP', 'ARS', 'CAD'],
    taxYear: 'Exercício 2026 (Receita Federal)',
    standardVatRate: 17.0,
  },
  {
    code: 'MX',
    name: 'Mexico',
    currency: 'MXN',
    currencySymbol: '$',
    flag: '🇲🇽',
    locale: 'es-MX',
    popularCurrencies: ['USD', 'EUR', 'CAD', 'GBP', 'COP'],
    taxYear: 'Ejercicio Fiscal 2026 (SAT)',
    standardVatRate: 16.0,
  },
  {
    code: 'ZA',
    name: 'South Africa',
    currency: 'ZAR',
    currencySymbol: 'R',
    flag: '🇿🇦',
    locale: 'en-ZA',
    popularCurrencies: ['USD', 'GBP', 'EUR', 'AUD', 'CAD'],
    taxYear: '2026 Tax Season (SARS)',
    standardVatRate: 15.0,
  },
  {
    code: 'CM',
    name: 'Cameroon (CEMAC)',
    currency: 'XAF',
    currencySymbol: 'FCFA',
    flag: '🇨🇲',
    locale: 'fr-CM',
    popularCurrencies: ['EUR', 'USD', 'GBP', 'CAD', 'CNY'],
    taxYear: 'Loi de Finances 2026 (DGI)',
    standardVatRate: 19.25,
  },
  {
    code: 'NG',
    name: 'Nigeria',
    currency: 'NGN',
    currencySymbol: '₦',
    flag: '🇳🇬',
    locale: 'en-NG',
    popularCurrencies: ['USD', 'GBP', 'EUR', 'CAD', 'GHS'],
    taxYear: '2026 Finance Act (FIRS)',
    standardVatRate: 7.5,
  },
];

export const LIVE_EXCHANGE_RATES: Record<string, number> = {
  // Base USD
  'USD': 1.0,
  'EUR': 0.9234,
  'GBP': 0.7911,
  'CAD': 1.3542,
  'CHF': 0.8845,
  'JPY': 149.82,
  'AUD': 1.5218,
  'SGD': 1.3412,
  'INR': 83.15,
  'AED': 3.6725,
  'BRL': 5.042,
  'MXN': 17.12,
  'ZAR': 18.78,
  'XAF': 605.71,
  'XOF': 605.71,
  'NGN': 1485.5,
};
